import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class SlsPortadorClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async getItems(queries = {}) {
    try {
      const { data } = await this.api.get('/portador');
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Portador');
    }
  }

  async index(queries = {}) {
    try {
      return await this.api.get('/portador', { params: queries });
    } catch (error) {
      throw this.error.message(error, 'Erro ao listar as Portador');
    }
  }

  async store(data) {
    try {
      const { data: response } = await this.api.post('/portador', data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao criar as Portador');
    }
  }

  async show(id) {
    try {
      const { data } = await this.api.get(`/portador/${id}`);
      return data;
    } catch (error) {
      throw this.error.message(error, 'Erro ao buscar a Portador');
    }
  }

  async update(id, data) {
    try {
      const { data: response } = await this.api.put(`/portador/${id}`, data);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao atualizar a Portador');
    }
  }

  async destroy(id) {
    try {
      const { data: response } = await this.api.delete(`/portador/${id}`);
      return response;
    } catch (error) {
      throw this.error.message(error, 'Erro ao deletar a Portador');
    }
  }
}
